import { render, staticRenderFns } from "./CardDeckShareCollaboration.vue?vue&type=template&id=49920646&scoped=true"
import script from "./CardDeckShareCollaboration.vue?vue&type=script&lang=js"
export * from "./CardDeckShareCollaboration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49920646",
  null
  
)

export default component.exports